enum BuyInStoreModalEnum {
	buyInStore = 'buyInStore'
}
export default BuyInStoreModalEnum;
